import { resolveImagePath } from '@/utils/imageResolver';
import thingsToDoData from '@/data/things-to-do.json';
import type { ThingsToDoData } from '@/data/types';

const data = thingsToDoData as ThingsToDoData;

export function ThingsToDo() {
  return (
    <section className="bg-white py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-teal-900 mb-4">
            {data.title}
          </h2>
        </div>

        {/* Attractions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {data.attractions.map((attraction, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              {/* Image */}
              <div className="h-48 overflow-hidden">
                <img
                  src={resolveImagePath(attraction.image)}
                  alt={attraction.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {attraction.name}
                </h3>
                <p className="text-gray-600 text-sm line-clamp-3">
                  {attraction.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}